import { render, staticRenderFns } from "./ReleasesCard.vue?vue&type=template&id=4a4e291c&scoped=true&"
import script from "./ReleasesCard.vue?vue&type=script&lang=js&"
export * from "./ReleasesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e291c",
  null
  
)

export default component.exports